import { Component, Inject, OnInit, signal } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { MatSnackBar } from "@angular/material/snack-bar";

import { BadgesService } from "../../services/badges/badges.service";
import { ImagesService } from "../../services/helper/images.service";
import { PersonService } from "../../services/person/person.service";
import { ProjectService } from "../../services/project/project.service";
import { UserService } from "../../services/user/user.service";

import { Router } from "@angular/router";
import { Project } from "app/shared/models/project.interface";
import { Observable } from "rxjs";
import { Persona, User } from "../../shared/models/user.interface";

@Component({
    selector: "app-dialog-dar-badge",
    templateUrl: "./dialog-dar-badge.component.html",
    styleUrls: ["./dialog-dar-badge.component.scss"],
    standalone: false
})
export class DialogDarBadgeComponent implements OnInit {
    badgeReturn: string;
    badgeStep: number;

    readonly personsSuggestion = signal<Persona[]>([]);
    readonly persons = signal<Persona[]>([]);
    hasMorePersons: boolean;
    currentPagePersons: number;

    filterPersonValue: string;

    userId: number;
    projectId: number;
    project: Project;
    readonly personSelected = signal<Persona | null>(null);
    readonly personsSelected = signal<Persona[]>([]);
    competencySelected: any;
    readonly competencies = signal<any>(null);
    indicators: Array<any>;
    motivation: string;
    minIndicators: number;
    maxIndicators: number;
    minCharacters: number;
    numIndicatorsSelected: number;
    limitePersonasAlcanzado: boolean = false;

    personsTab: Observable<Persona[]>;

    badgeTab: number = 0;
    projectConfig;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { badgeReturn: string; personId: number },
        private dialogRef: MatDialogRef<DialogDarBadgeComponent>,
        private snackBar: MatSnackBar,
        private projectSvc: ProjectService,
        private imagesSvc: ImagesService,
        private badgeSvc: BadgesService,
        private userSvc: UserService,
        private personSvc: PersonService,
        private router: Router
    ) {
        this.badgeReturn = "";
        this.badgeStep = 0;
        this.filterPersonValue = "";

        this.indicators = [];
        this.hasMorePersons = false;
        this.currentPagePersons = 0;

        this.motivation = "";

        this.competencySelected = null;
        this.numIndicatorsSelected = 0;
        this.limitePersonasAlcanzado = false;
        this.projectConfig = this.projectSvc.projectConfig;
    }

    ngOnInit(): void {
        if (this.data !== undefined && this.data !== null) {
            this.badgeReturn = this.data.badgeReturn;

            if (this.data.personId) {
                this.getPerson(this.data.personId);
            }
        }

        this.projectId = parseInt(this.projectSvc.getProjectId());

        if (this.projectConfig.tandemMode == 1) {
            this.badgeTab = 2;
        }

        this.userSvc.getUser().subscribe(
            (data: User) => {
                this.userId = data.id;
            },
            (err) => {
                this.showSnack(err);
            }
        );

        this.projectSvc.getProjectConfig().subscribe(
            (data) => {
                this.project = data;
                this.minCharacters = this.project.badgeMinCharacters;
                this.minIndicators = this.project.badgeMinIndicators;
                this.maxIndicators = this.project.badgeMaxIndicators;
                if (!this.project.entryPoint.enabled_badges) {
                    this.dialogRef.close();
                }
            },
            (err) => {
                this.showSnack(err);
            }
        );

        if (this.projectConfig.tandemMode == 1) {
            this.getPersonsTandem();
        } else {
            this.getPersonsSuggestion();
        }
    }

    getPersonsSuggestion() {
        this.badgeSvc.getPersonSuggestion().subscribe(
            (data) => {
                this.addSuggestion(data.lastRecievedBadgePerson);
                this.addSuggestion(data.lastDeliveredBadgedPerson);
                this.addSuggestion(data.mostBadgedPerson);
                this.addSuggestion(data.departmentPerson);
            },
            (err) => {
                this.showSnack(err);
            }
        );
    }

    private addSuggestion(person: Persona | null | undefined): void {
        if (!person) {
            return;
        }
        const current = this.personsSuggestion();
        if (current.some((item) => item.id === person.id)) {
            return;
        }
        this.personsSuggestion.set([...current, person]);
    }

    filterPersons(event: Event) {
        if (this.filterPersonValue.length > 2) {
            this.currentPagePersons = 0;
            this.persons.set([]);
            this.getPersons();
        } else {
            this.currentPagePersons = 0;
            this.persons.set([]);
        }
    }

    getPersons() {
        this.personSvc.getPersons(this.filterPersonValue, this.currentPagePersons, 5).subscribe(
            (personsData) => {
                const elements = personsData?.elements ?? [];
                this.persons.set([...elements]);
            },
            (err) => {
                this.showSnack(err);
            }
        );
    }

    getPerson(personId) {
        this.personSvc.getPerson(personId).subscribe((data) => {
            this.selectPerson(data);
        });
    }

    getCompetencies() {
        let personId: number | undefined = this.personSelected()?.id;
        if (personId == null && this.badgeTab === 1) {
            const group = this.personsSelected();
            personId = group[group.length - 1]?.id;
        }
        if (personId == null) {
            return;
        }
        this.badgeSvc.getAvailableCompetencies(personId).subscribe(
            (data) => {
                this.competencies.set(data);
            },
            (err) => {
                this.showSnack(err);
            }
        );
    }

    getImagePerson(username: string) {
        return this.imagesSvc.getImageThumb(username);
    }

    getImagePersonGrande(username: string) {
        return this.imagesSvc.getImagePerson(username, this.projectId);
    }

    getImageCompetency(competencyId: number) {
        return this.imagesSvc.getImageCompetency(competencyId);
    }

    getImageDefaultMission() {
        return this.imagesSvc.getUrlImageDefaultMission();
    }

    getPuesto(person: Persona) {
        let puestoName = "";

        if (person.puestos.length > 0) {
            puestoName = person.puestos[0].puesto;
        }

        return puestoName;
    }

    getMision(person: Persona) {
        let mision = null;

        if (person?.puestos.length > 0) {
            mision = person.puestos[0].mision ? person.puestos[0].mision : null;
        }

        return mision;
    }

    selectCompetency(competency: any) {
        this.competencySelected = competency;

        if (this.competencySelected.indicators.length > 0) {
            this.indicators = this.competencySelected.indicators;
            for (const indicator of this.indicators) {
                indicator["isChecked"] = false;
            }
        } else {
            this.indicators = null;
        }

        // En Vygon, los valores(type=0) tienen configurado el número min y max de indicadores en el proyecto.
        // en las misiones(type=1) solo se puede seleccionar un indicador.
        if (this.projectId == 288) {
            if (this.competencySelected.type_competency === 0) {
                this.minIndicators = this.project.badgeMinIndicators;
                this.maxIndicators = this.project.badgeMaxIndicators;
            } else {
                this.minIndicators = 1;
                this.maxIndicators = 1;
            }
        }

        this.badgeStep = 3;
    }

    calNumIndicatorSelected(): void {
        this.numIndicatorsSelected = 0;
        if (this.indicators.length > 0) {
            for (const indicator of this.indicators) {
                if (indicator.isChecked) {
                    this.numIndicatorsSelected++;
                }
            }
        }
    }

    checkValidData(): boolean {
        let disabled = true;

        if (this.motivation.length >= this.minCharacters) {
            if (this.competencySelected.type_competency === 0 || this.projectId == 288) {
                if (
                    this.numIndicatorsSelected >= this.minIndicators &&
                    this.numIndicatorsSelected <= this.maxIndicators
                ) {
                    disabled = false;
                }
            } else {
                disabled = false;
            }
        }

        return disabled;
    }

    showSnack(mensaje: string) {
        this.snackBar.open(mensaje, "X", {
            duration: 3000
        });
    }

    selectPerson(user: Persona) {
        this.personSelected.set(user);
        this.badgeStep = 1;

        // Badges individuales. Iberext y Arcelor
        if (this.badgeTab == 0 && ["leroymerlin", "iberext", "arcelor"].includes(this.project.name)) {
            this.badgeStep = 2;
        }

        // Badge grupales.
        if (this.badgeTab == 1) {
            const selectedList = this.personsSelected();
            if (selectedList.length < this.project.maxBadgeGrantee) {
                this.filterPersonValue = "";

                if (!this.containsUser(user, selectedList)) {
                    this.personsSelected.set([...selectedList, user]);
                }

                if (!this.competencies()) {
                    this.getCompetencies();
                }

                this.personSelected.set(null);
            } else {
                this.showSnack("No puede seleecionar más de " + this.project.maxBadgeGrantee + " personas.");
            }
        } else {
            this.filterPersonValue = user.displayName;
            this.getCompetencies();
        }

        this.competencySelected = null;
        this.persons.set([]);
    }

    clearPerson() {
        this.personSelected.set(null);
        this.filterPersonValue = "";

        if (this.badgeTab == 0) {
            this.badgeStep = 0;
            this.competencySelected = null;
            this.persons.set([]);
            this.indicators = [];
            this.competencies.set(null);
        }
    }

    emojiSelected(event) {
        const emoji = event.emoji && event.emoji.native ? event.emoji.native : null;
        if (emoji) {
            this.motivation = this.motivation + event.emoji.native;
        }
    }

    sendBadge(isPrivate) {
        let grantees = [];

        if (this.badgeTab == 1) {
            grantees = this.personsSelected();
        } else {
            const selected = this.personSelected();
            if (selected) {
                grantees.push(selected);
            }
        }

        let indicatorsChecked = null;
        if (this.indicators !== null) {
            indicatorsChecked = [];
            for (const itemIndicator of this.indicators) {
                if (itemIndicator.isChecked) {
                    indicatorsChecked.push(itemIndicator);
                }
            }
        }

        this.badgeSvc
            .sendBadge(
                this.userId,
                grantees,
                this.competencySelected,
                indicatorsChecked,
                this.motivation,
                this.badgeReturn,
                isPrivate
            )
            .subscribe(
                (data) => {
                    this.showSnack(
                        data.needModeration == 1
                            ? "Reconocimiento enviado a moderación"
                            : "Reconocimiento enviado correctamente"
                    );
                    this.dialogRef.close();
                    if (this.router.url == "/perfil" || this.router.url == "/inicio") {
                        this.badgeSvc.sendUpdate("Update");
                    }
                },
                (err) => {
                    if (err.status === 409 && err.error.message.error === "max_badge") {
                        this.showSnack("¡Has alcanzado el máximo de reconocimientos que puedes enviar!");
                    } else {
                        this.showSnack(err);
                    }
                }
            );
    }

    onTabChanged(event) {
        this.badgeTab = event.index;
        this.clearPerson();
        if (this.projectConfig.tandemMode == 1) this.getPersonsTandem();
    }

    unselectPersonArray(key: number) {
        const list = this.personsSelected();
        this.personsSelected.set(list.filter((_, i) => i !== key));
    }

    containsUser(obj, list) {
        var i;
        for (i = 0; i < list.length; i++) {
            if (list[i].id === obj.id) {
                return true;
            }
        }

        return false;
    }

    getPersonsTandem() {
        if (this.badgeTab == 2) {
            this.personsTab = this.personSvc.peopleFromPuestoName("ALUMNO/A"); // Alumnos
        } else if (this.badgeTab == 3) {
            this.personsTab = this.personSvc.peopleFromPuestoName("FORMADOR/A"); // Profesores
        } else if (this.badgeTab == 4) {
            this.personsTab = this.personSvc.peopleFromPuestoName("ETI"); // ETIs
        }
    }
}
